import React from "react";
import LayoutMain from "../../components/Layout/Main/Main";
import JournalDataCollection from "../../Partials/JournalData/Collection";
import DataJournal from "../../Data/Journal";

const Journal = () => {
  return (
    <LayoutMain>
      <section className="pt-85 pb-85 pt-sm-50 pb-sm-20 position-relative overflow-hidden">
        <div className="container-2">
          <div className="row align-items-center article-2 circular-std-book bg-beige position-relative clearfix no-gutters">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
              <div className="article-2-img">
                <img
                  src="images/journal-big-img.jpg"
                  className="img-fluid center-block img-100 transition"
                  alt=""
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4">
              <div className="article-2-content">
                <span className="article-2-date gibson-normal">
                  5 July 2017
                </span>
                <h1>A Modern Garden for a Historic Townhouse</h1>
                <p>
                  When Lauren Snyder and Keith Burns renovated their istoric
                  brownstone in brooklyn's Bedford-Stuyvents neighborhood
                </p>
                <a href="/" className="article-2-more">
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container-2">
          <div className="row extra-margin">
            <JournalDataCollection data={DataJournal} />
          </div>
          <div className="row mb-120">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="text-center mt-85 mt-sm-25">
                <a href="/" className="btn btn-grey-border btn-block center-block btn-all-post" >LOAD MORE</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </LayoutMain>
  );
};

export default Journal;
